export default {
  '/': 'Home',
  '/rhythm': 'Rhythm',
  '/ensemble': 'Ensemble',
   '/admin': 'Admin',
   '/team' : 'Team',
   '/payment' : 'Payment'
}



// WEBPACK FOOTER //
// ./src/routes.js